import TpCreditMemoService from '../../../../Services/CreditMemo/TpCreditMemoService';

export default class TpCreditMemoInvoiceViewDescription {
  static invoiceService = TpCreditMemoService.GetInvoicePdfById;
  static title = 'Credit Memo Preview';
  static fileNamePrefix = 'credit_memo';
  static attachInvoiceServiceFunction = TpCreditMemoService.AttachReportAsync;
}
